/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Circle } from 'react-native-svg';

import { IconProps } from '../lib';

function Gear(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M211.8501,133.12744c.20752-3.41528-.00049-10.25464-.00049-10.25464l16.5542-22.07177a103.36316,103.36316,0,0,0-10.16358-24.5608L190.918,72.33862a84.52765,84.52765,0,0,0-7.25195-7.25219L179.76514,37.7749a103.36081,103.36081,0,0,0-24.5542-10.18017l-22.07862,16.561a84.505,84.505,0,0,0-10.25586,0l-22.0708-16.55395A103.37063,103.37063,0,0,0,76.24512,37.76562L72.34375,65.08789a84.46168,84.46168,0,0,0-7.25244,7.2522L37.77979,76.24072a103.37861,103.37861,0,0,0-10.18018,24.5542l16.561,22.07862c-.20752,3.41528.00049,10.25463.00049,10.25463L27.60693,155.2a103.36309,103.36309,0,0,0,10.16358,24.56079l27.32226,3.90161a84.46312,84.46312,0,0,0,7.25244,7.2522l3.9004,27.31152a103.36018,103.36018,0,0,0,24.55419,10.18018l22.07862-16.561a84.50294,84.50294,0,0,0,10.25586,0l22.0708,16.554a103.37032,103.37032,0,0,0,24.56054-10.16382l3.90186-27.32226c2.56152-2.26807,7.25049-7.25171,7.25049-7.25171l27.313-3.90113a103.37883,103.37883,0,0,0,10.18017-24.5542ZM128.00488,176a48,48,0,1,1,48-48A47.99988,47.99988,0,0,1,128.00488,176Z"
        opacity={0.2}
      />
      <Circle
        cx={128.00488}
        cy={128}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Path
        d="M183.66575,65.08649a84.52233,84.52233,0,0,1,7.2522,7.2521l27.32235,3.90156A103.37019,103.37019,0,0,1,228.404,100.801L211.84953,122.8728s.20824,6.83942.00066,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554L190.918,183.66144s-4.689,4.98345-7.2507,7.25163l-3.90156,27.32234a103.36981,103.36981,0,0,1-24.56086,10.16371l-22.0704-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.36931,103.36931,0,0,1-24.554-10.18033L72.345,190.91449a84.521,84.521,0,0,1-7.2522-7.25211l-27.32234-3.90155A103.36971,103.36971,0,0,1,27.60674,155.2l16.55447-22.07178s-.20824-6.83942-.00065-10.2547l-16.561-22.07863a103.36914,103.36914,0,0,1,10.18033-24.554l27.31148-3.90076a84.521,84.521,0,0,1,7.25211-7.2522L76.245,37.76556a103.37009,103.37009,0,0,1,24.56087-10.1637l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561A103.37,103.37,0,0,1,179.765,37.775Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default Gear;
